// src/routes/domains/germany/index.ts
import { germanyRoutes } from './germany.routes';




import type { AppRoute } from '../../core/types';

export const loadGermanyRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(germanyRoutes);
};